import { component as defineComponent, utils } from 'flightjs'; // eslint-disable-line no-restricted-imports

function TagInput() {
    this.defaultAttrs({
        currentInputValue: '',
        caseSensitive: null,
    });

    this.intervalSuggestionAbort = null;

    // Request suggestion data from data component, passing the input value
    this.requestSuggestionsData = utils.debounce(function() {
        // interval to trigger Suggestion Abort when value is empty.
        if (!this.intervalSuggestionAbort) {
            this.intervalSuggestionAbort = setInterval(() => {
                if (this.$node.val() == '') {
                    this.resetInput();
                }
            }, 50);
        }

        if (this.attr.currentInputValue !== this.$node.val()) {
            this.attr.currentInputValue = this.$node.val();

            this.trigger('dataSuggestionsDataRequested', {
                userString: this.userString(),
            });
        }
    }, 200);

    this.userString = function() {
        if (!this.attr.caseSensitive) {
            this.attr.currentInputValue = this.attr.currentInputValue.toLowerCase();
        }
        return this.attr.currentInputValue;
    };

    // Capture keydown event to capture specific user actions
    this.keyDown = function(event) {
        switch (event.keyCode) {
            // <TAB>: Keep default functionality and reset input field
            case 9:
                this.resetInput();
                break;

            // <RETURN>: Prevent default browser form submit and confirm selected tag
            case 13:
                event.preventDefault();
                this.trigger('uiSuggestionsConfirm');
                break;

            // <ESC>: Reset input field
            case 27:
                event.preventDefault();
                this.resetInput();
                break;

            // <ARROWUP>: Move up in suggestion list
            case 38:
                event.preventDefault();
                this.trigger('uiSuggestionsMoveUp');
                break;

            // <ARROWDOWN>: Move down in suggestion list
            case 40:
                event.preventDefault();
                this.trigger('uiSuggestionsMoveDown');
                break;
            default:
                break;
        }
    };

    // Clear input when user wants to cancel (hits <TAB> or <ESC>)
    this.resetInput = function() {
        this.$node.val('');
        this.attr.currentInputValue = '';
        this.trigger('uiSuggestionsAbort', {
            userString: '',
        });
    };

    // Emmit event that input got focus
    this.inputFocused = function() {
        this.trigger('uiTagInputFocused', {
            userString: this.$node.val(),
        });
    };

    this.after('initialize', function() {
        // Capture keyboard events
        this.on('keyup', this.requestSuggestionsData);
        this.on('keydown', this.keyDown);
        this.on('focusin', this.inputFocused);

        // If selection is made reset input
        this.on('uiSuggestionsSelected', this.resetInput);
    });
}

export default defineComponent(TagInput);



// WEBPACK FOOTER //
// ./src/js/component_ui/tag-input.js